import { defineMessages, IntlShape } from "react-intl";

enum ReportCategory {
  CUSTOM = "CUSTOM",
  GENERAL = "GENERAL",
  PERFORMANCE = "PERFORMANCE",
  EXPORTS = "EXPORTS",
}

const categoryMessages = defineMessages({
  [ReportCategory.CUSTOM]: {
    id: "reports.menu.category.customReports",
    defaultMessage: "Custom Reports",
    description: "Settings Menu - Personal setting",
  },
  [ReportCategory.EXPORTS]: {
    id: "reports.menu.category.exports",
    defaultMessage: "Exports",
    description: "Settings Menu - Notification And Privacy setting",
  },
  [ReportCategory.GENERAL]: {
    id: "reports.menu.category.generalReports",
    defaultMessage: "General Reports",
    description: "Settings Menu - Personal setting",
  },
  [ReportCategory.PERFORMANCE]: {
    id: "reports.menu.category.leaderboard",
    defaultMessage: "Performance Reports",
    description: "Settings Menu - Organization setting",
  },
});

export const getCategoryMessagesDisplayName = (intl: IntlShape, reportType: ReportCategory) =>
  intl.formatMessage(categoryMessages[reportType]);

export default ReportCategory;
